export { default, default as RecentMeeting } from "./RecentMeeting";
